export const MOBILE_FIELD_TYPE = {
	date: 'date',
	integer: 'integer',
};

export type MobileFieldTypeEnumType = keyof typeof MOBILE_FIELD_TYPE;
